import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SettlementBalancingOverview } from 'views/orders/settlement/components/settlement-balancing-overview';
import { NewOrderType } from 'types/order';

type BalancingTableProps = {
  order: NewOrderType;
};

export const BalancingTable: FC<BalancingTableProps> = ({ order }) => {
  const { t } = useTranslation('closingDisclosure');

  if (!order.accounting || order.accounting.length === 0) {
    return null;
  }

  return (
    <SettlementBalancingOverview
      accounting={order.accounting}
      t={t}
    />
  );
};
